
    <template>
  <v-footer class="d-flex pa-2 justify-center">
      
  <v-btn class="mx-4" href="https://werner.dfki.de/confidentiality" text small>Datenschutz</v-btn>
  <v-btn class="mx-4" href="https://werner.dfki.de/impressum" text small>Impressum</v-btn>

  <!-- DATE
    <div>&copy; {{ new Date().getFullYear() }}</div> -->

  </v-footer>
</template>

<script>
export default {
    
}
</script>

<style>
a:hover {
  text-decoration: none !important;
}
</style>
